// removed by extract-text-webpack-plugin
module.exports = {"this---hidden":"u7zxgx8egtggsp3cjff8rtvqgj7ganutsy1j7g52fnu4qnsh65pjbp3tfem2km1g6zgbxzj62abymmrg4ysygvc9ma3ppgnb25mkwg-Label-module-this---hidden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Label/Label.module.scss
// module id = 319
// module chunks = 0